import React, { PropsWithChildren } from "react";

import { clsx } from "clsx";
import Tabledataloading from "./Tabledataloading";

type Props = {
  className?: string;
  centered?: boolean;
  colSpan?: number;
  dataLabel?: string;
  compact?: boolean;
  header?: boolean;
  scope?: "col" | "row" | "colgroup" | "rowgroup";
  sort?: boolean;
  my?: string;
  loading?: boolean;
  overlay?: boolean;
};

const Table = ({
  children,
  className,
  compact = false,
  loading = false,
  overlay = false,
  my,
}: PropsWithChildren<Props>) => (
  <div
    className={clsx({
      "table-wrapper": true,
      [`${className ? className : ""}`]: className,
      [`${my ? "my-" + my : ""}`]: my,
    })}
  >
    {loading && <Tabledataloading fill="#000" />}
    {overlay && <div className="table-data-overlay" />}

    <table
      className={clsx({
        compact,
      })}
    >
      {children}
    </table>
  </div>
);

Table.TableHeader = ({ children }: PropsWithChildren<Props>) => (
  <thead>
    <tr>{children}</tr>
  </thead>
);

Table.TableBody = ({ children }: PropsWithChildren<Props>) => <tbody>{children}</tbody>;

Table.TableRow = ({ children, className }: PropsWithChildren<Props>) => (
  <tr className={className}>{children}</tr>
);

Table.Cell = ({
  children,
  header,
  centered,
  colSpan,
  className,
  scope,
  sort,
  dataLabel,
}: PropsWithChildren<Props>) => {
  const cellType = header ? (
    <th
      className={clsx({
        "cell-header": true,
        centered,
        [`${className ? className : ""}`]: className,
      })}
      scope={scope}
      colSpan={colSpan}
      data-label={dataLabel}
    >
      {children}
      {sort && <i className="sort" />}
    </th>
  ) : (
    <td
      className={clsx({
        cell: true,
        centered,
        [`${className ? className : ""}`]: className,
      })}
      colSpan={colSpan}
      data-label={dataLabel}
    >
      {children}
    </td>
  );

  return cellType;
};

export default Table;
